import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Analytics from '../../Components/Analytics';
import TagManager from '../../Components/Analytics/TagManager';
import Mobile, { useMobile } from '../../Components/Mobile';
import UpdatePrompt from '../../Components/UpdatePrompt';

export default () => {
    return <div className="h-screen px-4 py-6">
        <ErrorBoundary>
            <DialoguesWrapper>
                <HelpWrapper>
                    <Mobile>
                        <ErrorBoundary>
                            <OnboardingLayout />
                        </ErrorBoundary>
                    </Mobile>
                </HelpWrapper>
            </DialoguesWrapper>
            <Analytics />
            <TagManager />
        </ErrorBoundary>
    </div>;
};

const OnboardingLayout = () => {
    const {safeAreaInsets, isAndroid} = useMobile();
    const bottomOffset = (safeAreaInsets && isAndroid) ? safeAreaInsets.bottom : null;

    return <div className="md:max-w-[560px] w-full h-full min-h-0 mx-auto flex flex-col">
        <div className="shrink-0">
            <img src="/logo-name-horizontal.png"
                alt="getSoapy Logo"
                width="888"
                height="183"
                className="w-[50%] max-w-[280px] h-auto mx-auto"
            />
        </div>

        <main className="flex-1 min-h-0 flex items-center py-6">
            <Outlet />
        </main>

        <div
            className="shrink-0 text-sm text-center"
            style={bottomOffset ? {paddingBottom: `${bottomOffset}px`} : undefined}
        >
            <Link to="/login" className="text-muted hover:text-brand">
                Already have an account? <span className="font-medium">Log in</span>
            </Link>
        </div>

        {/* Needs the Mobile context, so must render inside <Mobile> */}
        <UpdatePrompt />
    </div>;
};
